import React, { useContext, useEffect, useState } from "react";

import { Typography } from 'antd';
import { useLocation, useParams } from "react-router-dom";

import { getInfoEp, loadEpFile, putMarkedNode } from "../../shared/api/request";
import Close from "../../shared/components/Close";
import SubscribePage from "../../shared/components/SubscribePage";
import AuthContext from "../../shared/context/TokenContext";
import "../../shared/css/basicStyles.css";
import { BulleV2 } from "../../shared/types/Bubble";
import { Character } from "../../shared/types/Character";
import { Episode } from "../../shared/types/Episode";
import ReaderVisual from "../components/ReaderVisual";

const { Title, Text } = Typography;

const Reader = () => {
  const ctx = useContext(AuthContext);
  const { idEpisode, nodeId } = useParams();
  let { state } = useLocation();

  const [isBeneylu, setIsBeneylu] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [msgError, setMsgError] = useState("");
  const [bubbles, setBubbles] = useState<BulleV2[]>();
  const [characters, setCharacters] = useState<Character[]>([]);
  const [nextEp, setNextEp] = useState<Episode | undefined>();

  const [visibleBubble, setVisibleBubble] = useState<number>(-1);
  
  const [episode, setEpisode] = useState<Episode | undefined>(undefined);
  const [idSerie, setIdSerie] = useState<number>(-1);
  const [params, setParams] = useState<any>({ isDys: false, fontSize: 1 });

  const saveLastVisibleBubble = async () => {
    if (visibleBubble >= 0) {
      await putMarkedNode({
        epId: idEpisode,
        nodeId: visibleBubble,
        lastNode: bubbles && bubbles?.length - 1 <= visibleBubble,
      });
    }
  };

  useEffect(() => {
    const saveIndexBubble = setInterval(async () => {
      await saveLastVisibleBubble();
    }, 3000);

    return () => {
      clearTimeout(saveIndexBubble);
    };
  });

  useEffect(() => {
    if (!state || !state.episode) {
      // Load info Episode
      const load = async () => {
        const epServer = await getInfoEp(idEpisode);
        console.log("🚀 ~ load ~ epServer:", epServer)
        setEpisode(epServer.episode);
        setIdSerie(epServer.idSerie);
      };
      load();
    } else {
      setEpisode(state.episode);
      setIdSerie(state.idSerie);
      setParams(state.params);
    }
  }, [idEpisode, state]);

  useEffect(() => {
    const loader = async () => {
      console.log("🚀 ~ loader ~ idEpisode:", idEpisode);
      setIsLoading(true);
      if (ctx.isBeneylu) setIsBeneylu(ctx.isBeneylu());
      const data = await loadEpFile(idEpisode, true, true);
      console.log("🚀 ~ loader ~ data:", data)

      if (data.bubbles) {
        setBubbles(
          data.bubbles
          // .map((b: Bubble) => {
          //   if (b.text && b.text.length > 0)
          //     b.text = b.text.replaceAll("<", "").replaceAll(">", "");
          //   return b;
          // })
        );
        if (data.infosEpToSend) setCharacters(data.infosEpToSend);
        setNextEp(data.nextEpToSend);
      } else {
        if (data.status === 401)
          setMsgError("Vous devez être abonné pour accéder à cet épisode.");
        else setMsgError("Erreur inconnu");
      }
      setIsLoading(false);
    };
    loader();
  }, [ctx, idEpisode, nodeId]);

  if(ctx.isEdifice?.() && msgError && msgError.length > 0)
    return (
      <div className="mainContainer">
        <div
          style={{
            minHeight: '100vh',
            backgroundColor: '#120d35',
            justifyContent: 'center',
            alignItems: 'center',
            display: 'flex',
            flexDirection: 'column',
          }}>
          <Title
            level={3}
            style={{
              color: 'white',
              textAlign: 'center',
              marginBottom: 32,
              marginTop: 32,
            }}>
            Cet épisode ne t'a pas encore été assigné
          </Title>
          <Text style={{ color: 'white', fontSize: 16, marginTop: 24 }}>Demande à ton enseignant de te débloquer cet épisode pour le lire</Text>
        </div>
        <Close to={".."} />
      </div>
    );

  if (msgError && msgError.length > 0)
    return (
      <div className="mainContainer">
        <SubscribePage />
        <Close to={".."} />
      </div>
    );

  return (
    <div className="mainContainer">
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {isLoading ?(<div className="loader" />) : 
        <ReaderVisual
          epName={`EP${episode?.number} - ${episode?.name}`}
          idSerie={idSerie}
          bubbles={bubbles}
          characters={characters}
          nextEp={nextEp}
          isLoading={isLoading}
          setViewableItem={(_bubble: BulleV2, index: number) => {
            setVisibleBubble(index);
          }}
          params={params}
          isBeneylu={isBeneylu}
        />}
      </div>
    </div>
  );
};

export default Reader;
